<template>
  <div class="side-menu" :class="{'overlay-menu': !collapse, }">
    <ul class="nav flex-column">
      <div>
        <span>
          <div @click="toHome()" style=" text-align: left;margin-left: 12px;height: 64px;">
            <img v-show="collapse" class="Favi" :src="require('@/assets/imgs/icon.png')" alt />
            <img
              v-show="!collapse"
              class="Favi"
              :src="require('@/assets/imgs/logo-white.png')"
              style="width:130px"
              alt
            />
          </div>

          <!-- <div class="nav-head py-4">
            <v-icon name='search' style="margin:2px;" ></v-icon>
            Search 
          </div>-->
          <!-- <button type="button" class="close text-right" @click="collapseSideBar()">&times;</button> -->
        </span>
        <router-link
          class="item"
          :class="{'nav-link': collapse,}"
          role="tab"
          v-for="(item, key) in menu"
          :to="{ name: item.to }"
          tag="li"
          active-class="active"
          :key="key"
        >
          <div class="nav-icon" :style="collapse ? '':'margin:12px;color:white;'">
            <img
              :src="require('@/assets/imgs/terminal-page/terminal.png')"
              class="icon"
              style="margin-top: 3px; padding-top:5px;"
              :name="item.icon"
            />
          </div>
          <p v-show="!collapse" id="itemName">{{item.name}}</p>
          <!-- <div class="item-text">{{ item.name }}</div> -->
        </router-link>
      </div>

      <!-- <div @click="toggleCollapse" style="display:flex; position: absolute;bottom: 1rem; left: 1rem;">
        <v-icon style="color:#f5a623; margin-right:12px"
         :name="collapse ? 'chevron-right': 'chevron-left'"></v-icon>
         <transition name="fade">
          <p v-show="!collapse" id="itemName">Collapse</p>
         </transition>
      </div>-->
      <!-- <li class="nav-link item" @click="showLogout">
        <div class="nav-icon"><v-icon class="icon" style="width:40px" name="log-out"></v-icon></div>
      </li>-->
    </ul>
  </div>
</template>

<script>
/**
 * @author Fangzhou
 * @description the side bar of dashboard, contain navigation button which can tigger board switch event
 * @module bar
 * @name  SideBar
 */

export default {
  /**
   * @property menu {data} JsonArray which contain the information navigation on sidebar would need
   */
  data() {
    return {
      username: window.localStorage.getItem("username"),
      menu: [
        // {
        //   name: 'Account',
        //   icon: 'user',
        //   to: 'dash-board',
        //   active: false,
        // },
        // {
        //   name: "Terminal",
        //   icon: "terminal",
        //   to: "terminal-page",
        //   active: true
        // }
      ],
      collapse: false
    };
  },
  methods: {
    logo() {
      return this.collapse
        ? require("@/assets/imgs/icon.png")
        : require("@/assets/imgs/logo-white.png");
    },
    showLogout() {
      $("#logout").modal("show");
    },
    toHome() {
      this.$router.push({ name: "home-page" });
    },
    toggleCollapse() {
      this.collapse = !this.collapse;
    }
  }
};
</script>
<style lang="css" scoped>
* {
  font-family: Jura;
}

.side-menu {
  min-width: 10.6rem;
  width: 15%;
  transition: width x 0.5s;
  background-color: #1b2e38;
  filter: drop-shadow(0 0 8px black);
}

.nav {
  height: 100%;
  /* justify-content: space-between; */
  text-align: center;
  box-shadow: 4px 0 16px 0 #000000;
  z-index: 999;
}

.icon:hover {
  cursor: pointer;
}

.nav-link {
  color: white;
  padding: 0px;
  width: 64px;
  height: 64px;
}

.Favi {
  width: 40px;
  height: 40px;
  margin-right: 0px;
  margin-top: 12px;
  object-fit: contain;
}

.Favi:hover {
  cursor: pointer;
}

.nav-link:hover {
  /* border-left: solid 10px white; */
  transition: all 0.5s;
  color: white;
  opacity: 0.5;
}

.nav-head {
  background-color: #1b2e38;
  color: white;
  font-size: 20px;
  font-weight: bold;
  word-wrap: break-word;
  padding: 15px;
}

.icon {
  width: 32px;
}

.item-text {
  width: 100%;
  overflow: hidden;
}

.item {
  -ms-flex-align: center !important;
  align-items: center !important;
  display: flex;
}

.item:hover {
  cursor: pointer;
}

.nav-icon {
  margin: auto;
  /* background-color: #f5a623; */
  border-radius: 4px;
  width: 40px;
  height: 40px;
}

#itemName {
  color: white;
  font-weight: bold;
  font-size: 20px;
}

#itemName:hover {
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.overlay-menu {
  width: 160px !important;
  /* position: fixed;
  z-index: 99; */
}

.nav-link:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/fixed/side-menu.vue